import React from 'react';
import { motion } from "framer-motion"
import { AttributionControl, ImageOverlay, MapContainer, Marker, Polygon, useMapEvents, FeatureGroup} from 'react-leaflet'
import "leaflet/dist/leaflet.css";
import { icon } from 'leaflet';
import {FreeSpaceTooltip, StyledPop, SpaceTooltip} from '../components/Tooltip';
import Maps from '../maps.json'


const Floor = ({isShown, floor}) =>{
    const mapVariants = {
        open: {
          opacity: 1,
        },
        closed: {
          opacity: 0,
          display: 'none'
        },
      }

    const imageBounds = [[0, 0], [100, 100]];
    return (
        <motion.div animate={isShown ? 'open' : 'closed'} transition={{
            delay: 0.1,
            opacity: { duration: 0.2 },
            default: { ease: "linear" }
          }} variants={mapVariants}  className={'flex justify-center gap-8'}>
            <p className='absolute z-30 top-10 text-4xl font-bold font-zion'>{floor.name}</p>
            <MapContainer
                className='absolute z-20 w-[100vw] h-[100vh]'
                zoom={2}
                center={[65, 50]} attributionControl={false}>
                <ImageOverlay
                url={floor.planimetryUrl} bounds={imageBounds}
                attribution={false}
                />

                <AttributionControl position="bottomright" prefix={false} />

                {floor.freeSpaces.map((space,index) => {
                    //loading free spaces
                    return <FeatureGroup key={index} pathOptions ={{color: '#ffd900' }}>
                        <Polygon positions={space.positions}/>
                        <StyledPop>
                            <FreeSpaceTooltip space={space}/>
                        </StyledPop>
                    </FeatureGroup>
                })}

                {floor.spaces.map((space,index) => {
                    //loading spaces

                    const markerIcon = icon({
                        iconUrl: space.icon.iconUrl,
                        iconSize: space.icon.iconSize,
                        iconAnchor: space.icon.iconAnchor,
                        popupAnchor: space.icon.popupAnchor
                    });

                    return <div key={index}>
                            <Marker position={space.icon.iconPosition} icon={markerIcon}>
                                <StyledPop>
                                <SpaceTooltip space={space}/>
                                </StyledPop>
                            </Marker>
                            <FeatureGroup pathOptions ={{color: space.color}}>
                            <Polygon positions={space.positions}/>
                            <StyledPop>
                                <SpaceTooltip space={space}/>
                            </StyledPop>
                        </FeatureGroup>
                    </div>
                })}
                <Addons isShown={isShown}></Addons>
            </ MapContainer>
        </motion.div>
    )
}


const Addons = ({isShown}) => {
    const map = useMapEvents({
        click(ev) {
            console.log(map.mouseEventToLatLng(ev.originalEvent))
        },
      })

      if(!isShown){
        map.closePopup();
      }
     return (<></>)
}


const MapViewer = ({mapIndex, floorIndex}) => {
    return(
        <div id='test'>
            { 
                Maps.maps[mapIndex].floors.map((floor,index) => <Floor key={index} floor={floor} isShown={floorIndex === index}/>)
            }
        </div>
    )
}

export default MapViewer